import { render } from "./Venue2023SpringFall.vue?vue&type=template&id=41d95d1c"
import script from "./Venue2023SpringFall.js?vue&type=script&lang=js"
export * from "./Venue2023SpringFall.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__